import { render, staticRenderFns } from "./ZhanhuiListDialog.vue?vue&type=template&id=0058daa0&scoped=true"
import script from "./ZhanhuiListDialog.vue?vue&type=script&lang=js"
export * from "./ZhanhuiListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058daa0",
  null
  
)

export default component.exports